import { Link, Menu, Navbar, Spacer } from '@lego/klik-ui';
import { matchPath, Link as ReactRouterLink, useLocation } from 'react-router-dom';
import { ReportIssue } from '../ReportIssue';
import { RoleToggle } from '../RoleToggle';

type Props = {
  navItems: readonly { path: string; label: string }[];
  navEmmaItems: readonly { path: string; label: string; isExternal?: boolean }[];
  isOpen: boolean;
  toggleMenu: () => void;
};
export const DesktopNavigationBar = ({ navItems, navEmmaItems, isOpen, toggleMenu }: Props) => {
  const { pathname } = useLocation();
  const isActive = (path: string) => matchPath(path, pathname) !== null;

  return (
    <>
      <Navbar.Segment display={{ base: 'none', md: 'flex' }}>
        {navItems.map((item) => (
          <Navbar.Item
            as={ReactRouterLink}
            isActive={isActive(item.path)}
            key={item.path}
            to={item.path}
          >
            {item.label}
          </Navbar.Item>
        ))}
      </Navbar.Segment>
      <Spacer />
      <Navbar.Segment display={{ base: 'none', md: 'flex' }}>
        <ReportIssue />
        <Menu isOpen={isOpen}>
          <Menu.Button alignSelf="center" as={Link} onClick={toggleMenu} tabIndex={0}>
            <Navbar.Burger display={{ base: 'none', md: 'flex' }} />
          </Menu.Button>
          <Menu.List display={{ base: 'none', md: 'block' }}>
            {navEmmaItems.map((item) => {
              return item.isExternal ? (
                <Navbar.Item
                  href={item.path}
                  key={item.path}
                  onClick={toggleMenu}
                  p={2}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {item.label}
                </Navbar.Item>
              ) : (
                <Navbar.Item
                  as={ReactRouterLink}
                  color={isActive(item.path) ? 'blue' : 'none'}
                  isActive={isActive(item.path)}
                  key={item.path}
                  onClick={toggleMenu}
                  p={2}
                  to={item.path}
                >
                  {item.label}
                </Navbar.Item>
              );
            })}
            <RoleToggle onRoleChanged={toggleMenu} />
          </Menu.List>
        </Menu>
      </Navbar.Segment>
    </>
  );
};
